module.exports = __webpack_public_path__ + "static/3_1-self-driving-car-3df5927d7aaf46c5a637bbef803bbbb3.svg";